// Registry for all resource papers. Adding a new whitepaper is a matter of
// dropping a new file alongside these and importing it here.

import useStratiaInClaudeAndChatgpt from './use-stratia-in-claude-and-chatgpt';
import tellStratiaEverything from './tell-stratia-everything';
import buildingYourApplicationStrategy from './building-your-application-strategy';
import boilerplateMajorTrap from './boilerplate-major-trap';
import whenYourSchoolDoesntOfferYourMajor from './when-your-school-doesnt-offer-your-major';
import instantReadDeepRead from './instant-read-deep-read';
import hiddenCostOfResearch from './hidden-cost-of-research';
import howStratiaBuildsRoadmap from './how-stratia-builds-roadmap';
import howStratiaWorksWithAiAgents from './how-stratia-works-with-ai-agents';
import makingSummerCount from './making-summer-count';
import readingRealDecisions from './reading-real-decisions';
import readingYourOdds from './reading-your-odds';
import howManyColleges from './how-many-colleges-to-apply-to';
import whatIsASafetySchool from './what-is-a-safety-school';
import shouldYouSubmitTestScores from './should-you-submit-test-scores';
import doesEarlyDecisionHelp from './does-early-decision-improve-your-chances';
import juniorYearTimeline from './junior-year-college-timeline';
import stratiaWithYourCounselor from './stratia-with-your-counselor';
import theEssayOnlyYouCanWrite from './the-essay-only-you-can-write';
import shareYourApplication from './share-your-application';
import whyWeOnlyShowRealWords from './why-we-only-show-real-words';
import whatCollegeActuallyCosts from './what-college-actually-costs';
import choosingACollegeIsTwoDecisions from './choosing-a-college-is-two-decisions';
import whyCampusVisitsMatter from './why-campus-visits-matter';
import theLaunchpad from './the-launchpad';
import depthOverBreadth from './depth-over-breadth';
import theBuilderTrack from './the-builder-track';
import patentPendingOnYourApplication from './patent-pending-on-your-application';
import yourOwnResearchOnYourApplication from './your-own-research-on-your-application';

export const papers = [
    useStratiaInClaudeAndChatgpt,
    yourOwnResearchOnYourApplication,
    patentPendingOnYourApplication,
    whyWeOnlyShowRealWords,
    tellStratiaEverything,
    depthOverBreadth,
    theBuilderTrack,
    theLaunchpad,
    buildingYourApplicationStrategy,
    whyCampusVisitsMatter,
    choosingACollegeIsTwoDecisions,
    whatCollegeActuallyCosts,
    boilerplateMajorTrap,
    whenYourSchoolDoesntOfferYourMajor,
    instantReadDeepRead,
    readingRealDecisions,
    readingYourOdds,
    hiddenCostOfResearch,
    howStratiaBuildsRoadmap,
    howStratiaWorksWithAiAgents,
    makingSummerCount,
    howManyColleges,
    whatIsASafetySchool,
    shouldYouSubmitTestScores,
    doesEarlyDecisionHelp,
    juniorYearTimeline,
    stratiaWithYourCounselor,
    theEssayOnlyYouCanWrite,
    shareYourApplication,
];

export const papersBySlug = Object.fromEntries(
    papers.map((p) => [p.slug, p])
);

export const getPaperBySlug = (slug) => papersBySlug[slug] || null;

// Category chips for the /resources filter bar, in first-appearance order
// (matches the hand-curated order `papers` is already listed in above, so the
// chip row reads in the same priority as the grid) with a live count. Built
// from whatever the caller can currently see, so a gated paper never adds a
// category chip nobody browsing can select.
export const categoriesOf = (visible) => {
    const order = [];
    const counts = new Map();
    for (const p of visible) {
        if (!counts.has(p.category)) order.push(p.category);
        counts.set(p.category, (counts.get(p.category) || 0) + 1);
    }
    return order.map((name) => ({ name, count: counts.get(name) }));
};
